<template>
  <div class="container margin-auto activity-video">
    <div class="wapper">
      <img v-if="startVote" src="../../assets/images/activity/theX-header2.png">
      <img v-else src="../../assets/images/activity/theX-header.png">
      <div v-if="startVote" class="title-btn title-btn-rule" @click="showActivityDetail('01')">投票规则</div>
      <div v-if="startVote" class="title-btn title-btn-prize" @click="showActivityDetail('02')">奖品设置</div>
    </div>
    <div v-if="!startVote" class="title">
      <div class="title-text">
        <img src="../../assets/images/activity/theX-speaker.png">
        <div>THE X 内容会陆续推出，最终代言人由大家投票决定，排名决定权在大家手上哦，期待大家积极参与投票。</div>
      </div>
      <div class="title-time">投票时间：10月1日 - 10月23日</div>
    </div>

    <div class="content">
      <ul class="content-list">
        <li class="content-item" v-for="(item, index) in videoList" :key="index">
          <div class="content-title">
            <van-checkbox v-if="isShowVote && index < contentList.length" v-model="item.isCheck" shape="square" checked-color="#117281"
            @change="handleCheckVideo(index)">{{ item.period }}</van-checkbox>
          </div>
          <img class="content-img" :src="getImageUrl(index)" @click="viewVideo(index)">
          <div class="content-disc">{{ getText(index) }}</div>
          <div class="vote-num" v-if="isShowTotal && index < contentList.length">总票数: {{ item.voteTotal || 0 }}</div>
        </li>
      </ul>
    </div>
    <div class="vote-btn" v-if="isShowVote" @click="handleVote()">投票</div>

    <div v-if="startVote" class="footer">
      <div>注意事项：</div>
      <div>抽奖结果于2020年10月30日在易加网公众号公布并电话通知用户。</div>
      <div>本活动由博世易加网组织，在法律允许范围内，最终解释权归易加所有。</div>
    </div>

    <van-popup v-model="isShowPop" class="pop-content" :close-on-click-overlay="false">
      <div style="margin:20px 0 10px;text-align:center">{{ popContent }}</div>
      <div class="pop-btn" @click="isShowPop = false">好的</div>
    </van-popup>

    <van-dialog class="dialog" v-model="dialog.isShowDialog" :title="dialog.title">
      <div class="dialog-content" v-for="(item, index) in dialog.message" :key="index">
        <div v-if="!item.imgUrl">
          <p v-html="item"></p>
        </div>
        <div v-else class="dialog-image">
          <img :src="item.imgUrl">
        </div>
      </div>
    </van-dialog>

    <van-dialog class="histogram-dialog" v-model="isShowHistogram" title="投票结果">
      <div style="padding-top: 10px"></div>
      <div class="histogram-content" v-for="(item, index) in videoList" :key="index">
        <div class="histogram-title">{{ videoList[index].period }}</div>
        <div style="width:60%">
          <van-progress
            color="#117281"
            :show-pivot="false"
            :percentage="getPercentage(index)"
            stroke-width="17"
            :inactive="contentCodeList.indexOf(item.videoCode) === -1"/>
        </div>
        <div class="histogram-vote">{{ videoList[index].voteTotal }}</div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import activityApi from '@/api/activity'
import { commonUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
import { localStorageUtils } from '@/utils/localstorage'
import { sessionStorageUtils } from '@/utils/sessionstorage'
export default {
  name: 'ActivityVideo',
  components: {
  },
  data () {
    return {
      videoList: [
        { period: '第一期', videoCode: '1', isCheck: false, voteTotal: '0' },
        { period: '第二期', videoCode: '2', isCheck: false, voteTotal: '0' },
        { period: '第三期', videoCode: '3', isCheck: false, voteTotal: '0' },
        { period: '第四期', videoCode: '4', isCheck: false, voteTotal: '0' },
        { period: '第五期', videoCode: '5', isCheck: false, voteTotal: '0' },
        { period: '第六期', videoCode: '6', isCheck: false, voteTotal: '0' },
        { period: '第七期', videoCode: '7', isCheck: false, voteTotal: '0' },
        { period: '第八期', videoCode: '8', isCheck: false, voteTotal: '0' },
        { period: '第九期', videoCode: '9', isCheck: false, voteTotal: '0' },
        { period: '第十期', videoCode: '10', isCheck: false, voteTotal: '0' },
        { period: '第十一期', videoCode: '11', isCheck: false, voteTotal: '0' },
        { period: '第十二期', videoCode: '12', isCheck: false, voteTotal: '0' }
      ],
      contentList: [],
      voteList: [],
      contentCodeList: [],
      voteRecordTotalList: [],
      isShowVote: false,
      openId: '',
      isShowTotal: false,
      popContent: '',
      isShowPop: false,
      dialog: {
        isShowDialog: false,
        title: '',
        message: []
      },
      isShowHistogram: false,
      startDate: new Date('2020/10/01 00:00:00').getTime(),
      endDate: new Date('2020/10/23 16:00:00').getTime()
    }
  },
  mounted () {
    this.queryVideoData()
    this.isCanVote()
    this.initWxJsSdk()
  },
  computed: {
    startVote () {
      let currentTime = new Date().getTime()
      return currentTime > this.startDate
    }
  },
  methods: {
    // 是否能进行投票
    isCanVote () {
      let currentTime = new Date().getTime()
      if (currentTime > this.startDate && currentTime < this.endDate) {
        this.isShowVote = true
        if (!localStorageUtils.get('hasShowTheXRule')) {
          this.showActivityDetail('01')
          localStorageUtils.set('hasShowTheXRule', true)
        }
      }
      if (currentTime > this.endDate) {
        this.getVoteDetails()
        this.isShowTotal = true
      }
    },
    queryVideoData () {
      const params = {
        contentType: '04',
        scenarioType: '01'
      }
      // 正则 匹配数字 1-12
      const regex = /^([1-9]|10|11|12)$/
      activityApi.queryVideoData(params).then((response) => {
        if (response.data.resultCode === '0') {
          let contentList = response.data.resultData.contentList
          for (let i = 0; i < contentList.length; i++) {
            if (!regex.test(contentList[i].contentCode)) {
              contentList.splice(i, 1)
              i--
            }
          }
          contentList.sort((a, b) => {
            return a.contentCode - b.contentCode
          })
          this.contentList = contentList
          this.videoList.forEach((item, index) => {
            this.contentList.forEach((cItem, cIndex) => {
              if (index === cIndex) {
                item.videoCode = cItem.contentCode
              }
            })
          })
        }
      })
    },
    getImageUrl (index) {
      const currentDate = new Date().getTime()
      if (this.contentList[index] && this.contentList[index].contentCode && this.contentList[index].startDate <= currentDate) {
        return require('../../assets/images/activity/theX-content-' + this.contentList[index].contentCode + '.png')
      } else {
        return require('../../assets/images/activity/theX-content-defalut.png')
      }
    },
    viewVideo (index) {
      const currentDate = new Date().getTime()
      if (!this.contentList[index] || this.contentList[index].startDate >= currentDate) return
      const query = {
        target: this.contentList[index].targetUrl,
        contentId: this.contentList[index].contentId
      }
      this.$router.push({ name: 'TheXVideo', query: query })
    },
    getText (index) {
      const currentDate = new Date().getTime()
      if (!this.contentList[index] || this.contentList[index].startDate >= currentDate) {
        return '敬请期待...'
      } else {
        return this.contentList[index].contentTitle
      }
    },

    handleCheckVideo (index) {
      this.contentCodeList = []
      let video = this.contentList[index]
      let isExistIndex = this.voteList.indexOf(video)
      if (isExistIndex === -1) {
        this.voteList.push(video)
      } else {
        this.voteList.splice(isExistIndex, 1)
      }
      this.voteList.map(item => {
        this.contentCodeList.push(item.contentCode)
      })
    },

    showActivityDetail (type) {
      this.dialog.isShowDialog = true
      this.dialog.message = []
      if (type === '01') {
        this.dialog.title = '投票规则'
        this.dialog.message[0] = '1. 你投选的视频若获得冠军，你就有机会获奖；'
        this.dialog.message[1] =
        '2. 每人<span style="color:red">每天有1次</span>投票权，点页面右上角 <span class="share-btn">...</span> 可转发拉票；'
        this.dialog.message[2] = '3. 每次投票最多可投给<span style="color:red">3组</span>视频；'
        this.dialog.message[3] = '4. 非易加网用户可参与投票，但不能参与抽奖；'
        this.dialog.message[4] = '5. 所有易加网用户<span style="color:red">登录后</span>即可参与投票和抽奖。'
      }
      if (type === '02') {
        this.dialog.title = '奖品设置'
        this.dialog.message[0] = '大奖：博世高转速破壁机（1名）'
        this.dialog.message[1] = { imgUrl: require('../../assets/images/activity/theX-prize-01.jpg') }
        this.dialog.message[2] = '幸运奖：易加IP形象新品三件组合套装（10名）'
        this.dialog.message[3] = { imgUrl: require('../../assets/images/activity/theX-prize-02.png') }
      }
    },

    // 投票
    handleVote () {
      const clientInfo = userUtils.getClientInfo()
      // 用户未登录投票，弹出提示框
      if (!clientInfo) {
        this.$dialog.confirm({
          title: '提示',
          message: '您还未登录易加网账号\n是否继续投票？',
          confirmButtonText: '继续投票',
          cancelButtonText: '去登陆',
          className: 'vote-dialog'
        }).then(() => {
          this.confirmVote()
        }).catch(() => {
          this.$router.push({
            name: 'login',
            params: { redirectUrl: this.$route.name }
          })
        })
      } else {
        this.confirmVote()
      }
    },
    confirmVote () {
      const wxUserInfo = sessionStorageUtils.get('wxUserInfo') || {}
      if (this.contentCodeList.length > 3) {
        this.isShowPop = true
        this.popContent = '最多选择三个视频进行投票！'
        return
      }
      let params = {
        videoCodes: this.contentCodeList.join(','),
        wxOpenId: wxUserInfo.openId || '',
        wxNickName: wxUserInfo.wxNickName || ''
      }
      activityApi.voteVideo(params).then(res => {
        if (res.data.resultCode === '0') {
          this.videoList.map(item => item.isCheck === false)
          // this.isShowPop = true
          // this.popContent = '投票成功！'
          // 投票成功 获取投票详情
          this.getVoteDetails()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getVoteDetails () {
      activityApi.getVoteDetails().then(res => {
        if (res.data.resultCode === '0') {
          this.voteRecordTotalList = res.data.resultData.voteRecordTotalList || []
          this.videoList.forEach((item, index) => {
            this.voteRecordTotalList.forEach(childItem => {
              if (item.videoCode === childItem.videoCode) {
                item.voteTotal = childItem.voteTotal
              }
            })
          })
          let currentTime = new Date().getTime()
          if (currentTime > this.startDate && currentTime < this.endDate) {
            this.isShowHistogram = true
          }
        }
      }).catch(res => {
        console.log(res)
      })
    },

    // 初始化微信jssdk
    initWxJsSdk () {
      const url = `${document.location.origin}/v2/activity/activity-video`
      const appMessageShare = {
        title: 'THE X代言人投票', // 分享标题
        desc: '博世易加代言人甄选，快来帮我投票吧！', // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/extra-logo.png', // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('appMessageShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail')
        }
      }

      const timelineShare = {
        title: 'THE X代言人投票', // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/extra-logo.png', // 分享图标
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('timelineShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail' + url)
        }
      }
      commonUtils.configWxJsSdk(appMessageShare, timelineShare).then(() => {
        this.wxReady = true
      }).catch(error => {
        this.$emit('error', { errorMsg: error })
      })
    },
    // 得票数百分比
    getPercentage (index) {
      let voteArr = []
      for (let i = 0; i < this.videoList.length; i++) {
        voteArr.push(this.videoList[i].voteTotal)
      }
      let maxVote = Math.max(...voteArr)
      return Number(this.videoList[index].voteTotal) / maxVote * 100 || 0
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  min-height: 500px;
  width: 100%;
  padding-bottom: 10px;
}
.wapper {
  position: relative;
  // margin-bottom: 20px;
  img {
    width: 100%;
  }
  .title-btn {
    position: absolute;
    left: 0;
    padding: 0 5px;
    margin: auto 0px;
    line-height: 30px;
    background-color: rgba(240,240,240,.5);
    text-align: center;
    color: #000;
    font-size: 12px;
    border-top-right-radius: 13px;
    border-bottom-right-radius: 13px;
  }
  .title-btn-rule {
    top: 40px;
  }
  .title-btn-prize {
    top: 80px;
  }
}
.title {
  width: 90%;
  padding: 10px;
  font-size: 14px;
  font-weight: 600;
  background-color: #fff;
  margin: 10px auto 0 auto;
}
.title-text {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-bottom: 10px;
  font-weight: 600;
  line-height: 20px;
  color: #666;
  img {
    width: 50px;
    height: 44px;
    padding-right: 10px;
  }
}
.title-time {
  text-align: center;
  color: #117281;
}
.content {
  width: 90%;
  padding-top: 20px;
  margin: 0 auto;
}
.content-item {
  box-sizing: border-box;
  width: 49%;
  padding: 0 5px;
  text-align: center;
  margin-bottom: 20px;
  background-color: #fff;
}
.content-list {
  display: flex;
  justify-content: space-between;
  align-content: center;
  flex-wrap: wrap;
}
.content-title {
  padding: 5px 5px 10px 5px;
  text-align: left;
  line-height: 30px;
  font-size: 16px;
  font-weight: 600;
  img {
    width: 20px;
    height: 20px;
    vertical-align: sub;
  }
}
.content-img {
  width: 100%;
}
.content-disc {
  padding: 10px 5px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: #666;
}
.footer {
  padding: 10px 15px;
  font-size: 12px;
  color: #666;
  div {
    padding-bottom: 5px;
  }
}
.vote-num {
  padding: 0px 10px 10px 5px;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  color: #117281;
}
.vote-btn {
  width: 150px;
  height: 35px;
  margin: 10px auto 10px;
  background-color: #117281;
  color: #ffffff;
  text-align: center;
  line-height: 35px;
  border-radius: 5px;
}
.pop-content {
  width: 80%;
  margin: 0 auto;
  padding: 20px 30px;
  border-radius: 10px;
  box-sizing: border-box;
  line-height: 1.5;
  background-color: #fff;
}
.pop-btn {
  width: 180px;
  height: 35px;
  margin: 20px auto 0px;
  background-color: #117281;
  color: #ffffff;
  line-height: 35px;
  text-align: center;
  border-radius: 5px;
}
.dialog {
  div:first-child {
    p {
      padding-top: 10px;
    }
  }
}
.dialog-content {
  margin: 0 auto;
  padding: 5px 10px;
  font-size: 14px;
  color: #646566;
  .dialog-image {
    text-align: center;
    width: 100%;
    img {
      width: 120px;
    }
  }
}
.histogram-content {
  display: flex;
  justify-content: space-between;
  padding: 5px 20px 5px 10px;
  text-align: center;
  font-size: 12px;
  .histogram-title {
    width: 60px;
    padding-right: 5px;
    font-weight: 600;
  }
  .histogram-vote {
    width: 60px;
    padding-left: 5px;
    font-weight: 600;
  }
  div {
    line-height: 20px;
  }
  .van-progress {
    background: none;
  }
}
</style>
<style>
.share-btn {
  display: inline-block;
  font-size: x-large;
  vertical-align: middle;
  line-height: 0;
  height: 15px;
  padding: 1px 5px;
  border-radius: 5px;
  background-color: #ddd;
}
.content-title .van-checkbox__icon .van-icon {
  border-radius: 5px;
}
</style>
